module.exports = __webpack_public_path__ + "static/media/icon_checkout_active.b1b12100.svg";